export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.5-1638.56',
  commitId: '5e189aa31647e2c63cab389828babdce25ff9d9f',
  commitTime: '2026-02-05T16:38:56.000Z',
});
